/* ==========================================================================
   PDP Main — galerij, lightbox, sticky bar en CPC-prijs-brug.
   Per sectie-instance gescoped via data-pdp-main="<section-id>".
   De prijs-brug leest de geselecteerde opc-variantprijs en spiegelt die naar
   de prijs-card, samenvatting en sticky bar. Onafhankelijk van CPC's interne
   markup: we mappen variant-id -> vooraf geformatteerde prijs (uit Liquid).
   ========================================================================== */
(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.pdpInit === '1') return;
    root.dataset.pdpInit = '1';

    /* ---------- Galerij-slider (swipe + thumbs + pijltjes + teller) ---------- */
    var viewport = root.querySelector('[data-pdp-viewport]');
    var slides = viewport ? [].slice.call(viewport.querySelectorAll('[data-pdp-slide]')) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var counterCur = root.querySelector('[data-pdp-counter-cur]');
    var navPrev = root.querySelector('[data-pdp-prev]');
    var navNext = root.querySelector('[data-pdp-next]');
    var curIndex = 0;

    function galleryGoTo(i, smooth) {
      if (!viewport || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      viewport.scrollTo({ left: viewport.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      curIndex = i;
      if (counterCur) counterCur.textContent = (i + 1);
      thumbs.forEach(function (t) {
        var ti = parseInt(t.getAttribute('data-index'), 10);
        t.classList.toggle('is-active', ti === i);
      });
      if (navPrev) navPrev.disabled = (i <= 0);
      if (navNext) navNext.disabled = (i >= slides.length - 1);
    }
    if (viewport && slides.length) {
      var scrollRaf = null;
      viewport.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          setActive(Math.round(viewport.scrollLeft / viewport.clientWidth));
        });
      }, { passive: true });
      setActive(0);
      // Tap-vs-swipe: een veeg mag de lightbox niet openen
      var downX = 0, downY = 0, moved = false;
      viewport.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; moved = false; }, { passive: true });
      viewport.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - downX) > 10 || Math.abs(e.clientY - downY) > 10) moved = true;
      }, { passive: true });
      viewport.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }
    if (navPrev) navPrev.addEventListener('click', function (e) { e.preventDefault(); galleryGoTo(curIndex - 1); });
    if (navNext) navNext.addEventListener('click', function (e) { e.preventDefault(); galleryGoTo(curIndex + 1); });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        if (thumb.hasAttribute('data-pdp-open-lightbox')) return; // "+N" opent lightbox
        e.preventDefault();
        galleryGoTo(parseInt(thumb.getAttribute('data-index'), 10) || 0);
      });
    });

    /* ---------- Lightbox (swipe + pijltjes + teller) ---------- */
    var lightbox = root.querySelector('[data-pdp-lightbox]');
    var lbViewport = root.querySelector('[data-pdp-lb-viewport]');
    var lbSlides = lbViewport ? [].slice.call(lbViewport.querySelectorAll('.pdp-lightbox__slide')) : [];
    var lbCounter = root.querySelector('[data-pdp-lb-counter-cur]');
    var lbPrev = root.querySelector('[data-pdp-lb-prev]');
    var lbNext = root.querySelector('[data-pdp-lb-next]');
    var lbIndex = 0;

    function lbSet(i) {
      lbIndex = i;
      if (lbCounter) lbCounter.textContent = (i + 1);
      if (lbPrev) lbPrev.disabled = (i <= 0);
      if (lbNext) lbNext.disabled = (i >= lbSlides.length - 1);
    }
    function lbGoTo(i, smooth) {
      if (!lbViewport || !lbSlides.length) return;
      i = Math.max(0, Math.min(lbSlides.length - 1, i));
      lbViewport.scrollTo({ left: lbViewport.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function openLB(i) {
      if (!lightbox) return;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { lbGoTo(i, false); lbSet(i); });
    }
    function closeLB() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-pdp-open-lightbox]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var idx = el.hasAttribute('data-index') ? (parseInt(el.getAttribute('data-index'), 10) || 0) : curIndex;
        openLB(idx);
      });
    });
    if (lbViewport && lbSlides.length) {
      var lbRaf = null;
      lbViewport.addEventListener('scroll', function () {
        if (lbRaf) return;
        lbRaf = requestAnimationFrame(function () {
          lbRaf = null;
          lbSet(Math.round(lbViewport.scrollLeft / lbViewport.clientWidth));
        });
      }, { passive: true });
    }
    if (lbPrev) lbPrev.addEventListener('click', function (e) { e.preventDefault(); lbGoTo(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function (e) { e.preventDefault(); lbGoTo(lbIndex + 1); });
    if (lightbox) {
      // Klik op de overlay (naast de foto) sluit; een veeg mag niet sluiten.
      var lbDownX = 0, lbDownY = 0, lbMoved = false;
      lightbox.addEventListener('pointerdown', function (e) { lbDownX = e.clientX; lbDownY = e.clientY; lbMoved = false; }, { passive: true });
      lightbox.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - lbDownX) > 10 || Math.abs(e.clientY - lbDownY) > 10) lbMoved = true;
      }, { passive: true });
      lightbox.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-pdp-close-lightbox')) { closeLB(); return; }
        if (lbMoved) return;                    // veeg → niet sluiten
        if (e.target.closest('button')) return; // pijltjes/sluitknop → niet sluiten
        if (e.target.tagName === 'IMG') return;  // op de foto → niet sluiten
        closeLB();                               // alles daarbuiten (overlay) → sluiten
      });
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLB();
        else if (e.key === 'ArrowLeft') lbGoTo(lbIndex - 1);
        else if (e.key === 'ArrowRight') lbGoTo(lbIndex + 1);
      });
    }

    /* ---------- Kleur-vakje: live uit de configurator ---------- */
    var colorpill = root.querySelector('[data-pdp-colorpill]');
    var paintColorpill = null;   /* gevuld als het vakje bestaat; ook gebruikt door de variantkeuze */
    if (colorpill) {
      var cpName = colorpill.querySelector('[data-pdp-colorpill-name]');
      var cpSub = colorpill.querySelector('[data-pdp-colorpill-sub]');
      var cpSw = colorpill.querySelector('[data-pdp-colorpill-sw]');
      var cpMode = colorpill.getAttribute('data-pdp-colorpill-mode') || 'cpc';
      /* Suffix komt uit een attribuut ipv uit de tekst zelf, anders plakt hij
         bij elke update opnieuw achter de vorige waarde. */
      var cpSubSuffix = colorpill.getAttribute('data-cp-suffix') || '';
      var wantLabel = (colorpill.getAttribute('data-color-label') || 'kleur').toLowerCase();

      /* Splitst "Mat zwart (RAL9005)" in een vette naam en een code eronder,
         en neemt het kleurvlak over van het aangeklikte staaltje. */
      paintColorpill = function (rawName, swatchEl) {
        var mainName = String(rawName || ''), code = '';
        var pm = mainName.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
        if (pm) { mainName = pm[1].trim(); code = pm[2].trim(); }
        if (mainName && cpName) cpName.textContent = mainName;
        if (cpSub) {
          cpSub.textContent = code
            ? (cpSubSuffix ? code + ' \u00b7 ' + cpSubSuffix : code)
            : cpSubSuffix;
        }
        if (swatchEl && cpSw) {
          var cs = getComputedStyle(swatchEl);
          if (cs.backgroundImage && cs.backgroundImage !== 'none') {
            cpSw.style.background = cs.backgroundImage; cpSw.style.backgroundSize = 'cover';
          } else if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent') {
            cpSw.style.background = cs.backgroundColor;
          }
        }
      };

      /* CPC-pad: ongewijzigd. Draait alleen als er een configurator staat. */
      if (cpMode === 'cpc') {
        var cpcScope = root.querySelector('[data-pdp-cpc]') || root;
        var updateColorpill = function () {
          var holders = cpcScope.querySelectorAll('.optionHolder');
          for (var h = 0; h < holders.length; h++) {
            var labelEl = holders[h].querySelector('.option-label');
            if (!labelEl) continue;
            if (labelEl.textContent.replace(/\*/g, '').trim().toLowerCase().indexOf(wantLabel) === -1) continue;
            var checked = holders[h].querySelector('input.swatch-input:checked, input.radio-input:checked');
            if (!checked) return;
            var vis = null;
            if (checked.id) vis = cpcScope.querySelector('label[for="' + checked.id + '"]');
            if (!vis && checked.parentElement) vis = checked.parentElement.querySelector('.swatch, .swatchLbl, label, span');
            paintColorpill(checked.getAttribute('data-value') || '', vis);
            return;
          }
        };
        cpcScope.addEventListener('change', function () { setTimeout(updateColorpill, 40); });
        var cpTries = 0;
        var cpPoll = setInterval(function () {
          cpTries++;
          if (cpcScope.querySelector('.optionHolder')) { clearInterval(cpPoll); updateColorpill(); }
          else if (cpTries >= 40) clearInterval(cpPoll);
        }, 500);
      }
    }

    /* ---------- Kleurfoto: een configurator-staaltje met data-imageswap springt naar zijn foto ----------
       De calculator zet op elk kleurstaaltje de bestandsnaam van de bijbehorende productfoto
       (bijv. data-imageswap="Sidetable_achter_bank_RAL_8019_Grijsbruin"). Die zoeken we op in de
       slides en daar scrollen we heen. Geen match = galerij met rust laten. */
    if (slides.length) {
      var normImg = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.getAttribute || !t.checked) return;
        var key = normImg(t.getAttribute('data-imageswap'));
        if (!key) return;
        for (var si = 0; si < slides.length; si++) {
          var im = slides[si].querySelector('img');
          var file = im ? normImg((im.getAttribute('src') || '').split('/').pop().split('?')[0]) : '';
          if (file && file.indexOf(key) > -1) { if (si !== curIndex) galleryGoTo(si); return; }
        }
      });
    }

    /* ---------- Accordions ---------- */
    root.querySelectorAll('.pdp-acc__head').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.pdp-acc__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- Sticky bestelbalk ---------- */
    var stickybar = root.querySelector('[data-pdp-stickybar]');
    var anchor = root.querySelector('[data-pdp-sticky-anchor]');
    if (stickybar && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // toon zodra het anker (CTA/prijs-card) uit beeld is naar boven
          if (en.boundingClientRect.top < 0 && !en.isIntersecting) {
            stickybar.classList.add('is-visible');
          } else {
            stickybar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      io.observe(anchor);
    }

    /* ---------- CPC prijs-brug ---------- */
    var priceMap = {};
    var mapEl = root.querySelector('[data-pdp-price-map]');
    if (mapEl) { try { priceMap = JSON.parse(mapEl.textContent); } catch (e) {} }

    var priceTargets = root.querySelectorAll('[data-pdp-price]');
    var compareTargets = root.querySelectorAll('[data-pdp-compare]');

    /* ---------- Gespreid betalen: 'vanaf €X /maand' live uit de prijs ---------- */
    var instEl = root.querySelector('[data-pdp-installment]');
    var instAmtEl = root.querySelector('[data-pdp-installment-amount]');
    /* Bedrag lezen in elke schrijfwijze. De configurator-app schrijft in de
       TAAL VAN DE BROWSER van de klant: nl "€1.391", en "€1,391", fr "1 391 €",
       de-CH "1'391". Scheidingsteken + precies 3 cijfers = duizendtal, + 1 of 2
       cijfers = centen. Geeft centen terug, of null. (Incident 08-10-2026: een
       Engelse browser kreeg €2 te zien in plaats van €2.317.) */
    function leesCenten(str) {
      var m = ('' + (str || '')).replace(/[\s'’\u00a0\u202f]/g, '').match(/\d[\d.,]*/);
      if (!m) return null;
      var s = m[0].replace(/[.,]+$/, ''), c = s.match(/[.,](\d{1,2})$/);
      var euro = c ? parseFloat(s.slice(0, -c[0].length).replace(/[.,]/g, '') + '.' + c[1])
                   : parseFloat(s.replace(/[.,]/g, ''));
      return isFinite(euro) ? Math.round(euro * 100) : null;
    }
    /* Altijd Nederlandse notatie: €1.391 of €1.391,50 (centen alleen als die er zijn). */
    function toonCenten(cents) {
      var euros = Math.floor(cents / 100), c = cents % 100;
      var t = ('' + euros).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + t + (c ? ',' + (c < 10 ? '0' : '') + c : '');
    }
    function parseAmount(str) {
      var cents = leesCenten(str);
      if (cents == null) return null;
      return { cents: cents, sym: '€' };
    }
    function formatEuro(cents, sym) {
      var euros = Math.floor(cents / 100), c = cents % 100;
      var t = ('' + euros).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (sym || '€') + t + ',' + (c < 10 ? '0' : '') + c;
    }
    function updateInstallment(priceStr) {
      if (!instEl || !instAmtEl) return;
      var months = parseInt(instEl.getAttribute('data-months'), 10) || 6;
      var p = parseAmount(priceStr);
      if (!p || months < 1 || !p.cents) return;
      instAmtEl.textContent = formatEuro(Math.round(p.cents / months), p.sym);
    }

    function applyPrice(entry) {
      if (!entry) return;
      priceTargets.forEach(function (el) { if (el.textContent !== entry.price) el.textContent = entry.price; });
      compareTargets.forEach(function (el) {
        /* Alleen doorstrepen als de oude prijs echt hoger was. Staan prijs en
           compare-at in Shopify omgekeerd, dan zou je anders een prijs-
           verhoging als korting tonen. Numeriek vergelijken, niet op tekst. */
        var toon;
        if (typeof entry.compare_cents === 'number' && typeof entry.price_cents === 'number') {
          toon = entry.compare_cents > entry.price_cents;
        } else {
          toon = !!(entry.compare && entry.compare !== entry.price);
        }
        if (toon) {
          if (el.textContent !== entry.compare) el.textContent = entry.compare;
          el.style.display = '';
        } else { el.style.display = 'none'; }
      });
      updateInstallment(entry.price);
      /* De kortingsbadge luistert hierop: de variantkeuze zet de id
         programmatisch, dus er komt geen change-event langs. */
      document.dispatchEvent(new CustomEvent('pdp:price'));
    }

    function currentVariantId() {
      var form = root.querySelector('form[action*="/cart/add"], [data-pdp-cpc] form, form[data-type="add-to-cart-form"]');
      var scope = form || root;
      var input = scope.querySelector('[name="id"]');
      if (input) return input.value;
      var sel = scope.querySelector('select[name="id"]');
      if (sel) return sel.value;
      return null;
    }

    function syncFromVariant() {
      var id = currentVariantId();
      if (id && priceMap[id]) applyPrice(priceMap[id]);
    }

    // Eén keer initieel spiegelen. GEEN MutationObserver: CPC beheert prijs/
    // samenvatting/ATC zelf. We luisteren alleen naar echte variant-wijzigingen
    // via het 'change'-event op de variant-input (kan niet loopen).
    syncFromVariant();
    root.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') { syncFromVariant(); }
    });

    /* ---------- CPC totaalprijs -> spiegelen (configurator) ----------
       Leest CPC's eigen prijselement en spiegelt naar prijs-card/CTA/sticky.
       Observeert ALLEEN dat CPC-element (niet onze targets) -> geen loop.        */
    if (root.dataset.cpcPriceEnabled === 'true') {
      // De selector uit de instellingen gaat vóór, de standaard is de terugval.
      // Zo kan een calculator die zijn prijs elders neerzet (bv. .opc-new-price
      // bij een staffel) de standaard overrulen.
      var cpcSelector = root.dataset.cpcPriceSelector
        ? root.dataset.cpcPriceSelector + ', .addToCartCustomButtonPrice'
        : '.addToCartCustomButtonPrice';
      var cpcCompareSelector = root.dataset.cpcCompareSelector
        ? root.dataset.cpcCompareSelector + ', .opc-old-price'
        : '.opc-old-price';
      var cpcBox = root.querySelector('[data-pdp-cpc]') || root;
      var cpcPriceTargets = root.querySelectorAll('[data-pdp-price]');
      var cpcCompareTargets = root.querySelectorAll('[data-pdp-compare]');

      /* Prijs van de app omzetten naar onze eigen notatie, nooit de tekst van
         de app 1-op-1 overnemen: die staat in de browsertaal van de klant. */
      var extractPrice = function (txt) {
        var cents = leesCenten(txt);
        return cents ? toonCenten(cents) : '';
      };
      var nonZero = function (p) {
        var d = (p || '').replace(/[^\d]/g, '');
        return d && parseInt(d, 10) !== 0;
      };
      var findEl = function (selector) {
        var sels = selector.split(',');
        for (var i = 0; i < sels.length; i++) {
          var el = cpcBox.querySelector(sels[i].trim());
          if (el && /\d/.test(el.textContent)) return el;
        }
        return null;
      };
      var esc = function (s) {
        return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
      };
      // Lees generiek elke CPC-optie: label + gekozen waarde. Werkt voor elk configurator-product.
      var readCpcOptions = function () {
        var rows = [];
        cpcBox.querySelectorAll('.optionHolder').forEach(function (holder) {
          if (getComputedStyle(holder).display === 'none') return; // verborgen optie overslaan
          var labelEl = holder.querySelector('.option-label');
          if (!labelEl) return; // instructie-blokken zonder label overslaan
          var label = labelEl.textContent.replace(/\*/g, '').trim();
          var value = '';
          var qty = holder.querySelector('input.opc-quantity');
          var txt = holder.querySelector('input.option-number-input, .option-type-text input.text-input');
          if (qty) { value = (qty.value || '').trim(); }
          else if (txt && txt.value) { value = txt.value.trim(); }
          else {
            var vals = [];
            holder.querySelectorAll('input.swatch-input:checked, input.radio-input:checked').forEach(function (c) {
              var dv = c.getAttribute('data-value');
              if (dv) vals.push(dv);
            });
            value = vals.join(', ');
          }
          if (!value) return;
          rows.push({ label: label, value: value });
        });
        return rows;
      };
      var updateSummary = function () {
        var el = root.querySelector('[data-pdp-summary][data-summary-source="cpc"]');
        if (!el) return;
        var splitList = function (a) { return (el.getAttribute(a) || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
        var mergeLabels = splitList('data-summary-merge');
        var hideLabels = splitList('data-summary-hide');
        var mergeRowLabel = el.getAttribute('data-summary-merge-label') || 'Afmeting';
        var mergeUnit = el.getAttribute('data-summary-merge-unit') || '';
        var rows = readCpcOptions();
        if (!rows.length) return;
        var out = [], mergeVals = [], mergeInserted = false;
        rows.forEach(function (r) {
          if (hideLabels.indexOf(r.label) !== -1) return;
          if (mergeLabels.indexOf(r.label) !== -1) {
            mergeVals.push(r.value);
            if (!mergeInserted) { out.push({ merge: true }); mergeInserted = true; }
            return;
          }
          out.push(r);
        });
        var html = out.map(function (r) {
          var lbl = r.merge ? mergeRowLabel : r.label;
          var val = r.merge ? (mergeVals.join(' × ') + (mergeUnit ? ' ' + mergeUnit : '')) : r.value;
          return '<span class="pdp-summary__row"><span>' + esc(lbl) + '</span><b>' + esc(val) + '</b></span>';
        }).join('');
        if (el.innerHTML !== html) el.innerHTML = html;
      };

      var mirrorCpc = function () {
        var priceEl = findEl(cpcSelector);
        if (priceEl) {
          var price = extractPrice(priceEl.textContent);
          if (price && nonZero(price)) {
            cpcPriceTargets.forEach(function (t) { if (t.textContent !== price) t.textContent = price; });
            updateInstallment(price);
          }
        }
        // Korting: oude prijs doorgestreept spiegelen naar [data-pdp-compare]
        var oldEl = cpcBox.querySelector(cpcCompareSelector);
        var oldTxt = oldEl ? extractPrice(oldEl.textContent) : '';
        var hasDiscount = oldEl && oldTxt && nonZero(oldTxt);
        cpcCompareTargets.forEach(function (t) {
          if (hasDiscount) { if (t.textContent !== oldTxt) t.textContent = oldTxt; t.style.display = ''; }
          else { t.style.display = 'none'; }
        });
        updateSummary();
      };
      // Optiewijzigingen updaten de samenvatting (prijs komt via de observer op CPC's knop)
      cpcBox.addEventListener('change', function () { setTimeout(mirrorCpc, 40); });
      cpcBox.addEventListener('input', function () { setTimeout(updateSummary, 40); });
      // Pollen tot CPC gerenderd is; observeer daarna ALLEEN CPC's knop (bevat prijs + oude prijs),
      // nooit onze buybox -> geen loop.
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        var priceEl = findEl(cpcSelector);
        if (priceEl) {
          clearInterval(poll);
          mirrorCpc();
          var target = priceEl.closest('.addToCartCustomButton') || priceEl.closest('.shopify-app-block') || priceEl.parentElement;
          if (target && 'MutationObserver' in window) {
            new MutationObserver(mirrorCpc).observe(target, { subtree: true, childList: true, characterData: true });
          }
        } else if (tries >= 40) { clearInterval(poll); } // ~20s
      }, 500);
    }

    /* ---------- Aantal-stepper (voorraadproduct) ---------- */
    root.querySelectorAll('.pdp-qty').forEach(function (qty) {
      var input = qty.querySelector('.pdp-qty__input');
      var dec = qty.querySelector('[data-pdp-qty-dec]');
      var inc = qty.querySelector('[data-pdp-qty-inc]');
      if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });

    /* ---------- Variant-keuze (voorraadproduct) ----------
       Swatches en pills zijn radio's. Een niet-leverbare combinatie blijft
       kiesbaar maar wordt doorgestreept, zodat je ziet wat er niet is in
       plaats van dat het stilletjes verdwijnt.                              */
    var variantsEl = root.querySelector('[data-pdp-variants-json]');
    if (variantsEl) {
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
      var groups  = [].slice.call(root.querySelectorAll('.pdp-variant'));
      var idInput = root.querySelector('[data-pdp-variant-id]');
      var cta     = root.querySelector('[data-pdp-cta]');

      function chosen() {
        return groups.map(function (g) {
          var c = g.querySelector('.pdp-variant__input:checked');
          return c ? c.value : null;
        });
      }
      function match(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.options.length !== vals.length) continue;
          var ok = true;
          for (var j = 0; j < vals.length; j++) { if (v.options[j] !== vals[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function markAvailability(vals) {
        groups.forEach(function (g, gi) {
          g.querySelectorAll('.pdp-variant__input').forEach(function (inp) {
            var test = vals.slice(); test[gi] = inp.value;
            var v = match(test);
            var lbl = g.querySelector('label[for="' + inp.id + '"]');
            if (lbl) lbl.classList.toggle('is-unavailable', !(v && v.available));
          });
        });
      }
      function apply() {
        var vals = chosen();
        groups.forEach(function (g) {
          var c = g.querySelector('.pdp-variant__input:checked');
          var out = g.querySelector('[data-pdp-option-chosen]');
          if (out && c) out.textContent = c.value;
        });
        var m = match(vals);
        if (m && idInput) {
          idInput.value = m.id;
          syncFromVariant();
          if (cta) {
            cta.disabled = !m.available;
            cta.style.opacity = m.available ? '' : '.5';
            /* Een grijze knop die "In winkelwagen" blijft zeggen is verwarrend;
               bij een uitverkochte combinatie zetten we het label om en halen
               we de prijs weg. */
            var ctaLabel = cta.querySelector('[data-pdp-cta-label]');
            var ctaPrice = cta.querySelector('[data-pdp-cta-price]');
            if (ctaLabel) {
              ctaLabel.textContent = m.available
                ? (cta.getAttribute('data-label-add') || 'In winkelwagen')
                : (cta.getAttribute('data-label-soldout') || 'Uitverkocht');
            }
            if (ctaPrice) ctaPrice.style.display = m.available ? '' : 'none';
          }
          /* Hangt er een foto aan deze variant, spring dan naar die slide.
             Zonder gekoppelde foto laten we de galerij met rust: doorspringen
             naar slide 0 bij elke klik is vervelender dan niks doen. */
          /* Kleur-vakje op de foto meenemen (alleen als het vakje in
             variant-modus staat; bij een configurator doet het CPC-pad dat). */
          if (paintColorpill && colorpill && colorpill.getAttribute('data-pdp-colorpill-mode') === 'variant') {
            for (var gi = 0; gi < groups.length; gi++) {
              if (!groups[gi].classList.contains('pdp-variant--color')) continue;
              var chk = groups[gi].querySelector('.pdp-variant__input:checked');
              var lbl = chk ? groups[gi].querySelector('label[for="' + chk.id + '"]') : null;
              if (chk) paintColorpill(chk.value, lbl);
              break;
            }
          }
          if (m.image_id) {
            for (var si = 0; si < slides.length; si++) {
              if (slides[si].getAttribute('data-image-id') === String(m.image_id)) {
                if (si !== curIndex) galleryGoTo(si);
                break;
              }
            }
          }
        }
        markAvailability(vals);
      }

      groups.forEach(function (g) { g.addEventListener('change', apply); });
      apply();
    }

    /* ---------- In winkelwagen zonder de pagina te verlaten ----------
       Het blok gebruikt een gewoon Shopify-productformulier en dat post naar
       /cart. Kalles vangt alleen zijn eigen formulieren af, het onze dus niet,
       en daardoor belandde de klant op de winkelwagenpagina in plaats van in
       de lade. We voegen daarom zelf toe via /cart/add.js en laten de lade
       opengaan met het event waar het thema op luistert (cart:refresh:opend,
       hetzelfde event dat de configurator gebruikt). Gaat de fetch stuk, dan
       versturen we het formulier alsnog op de gewone manier, zodat iemand
       hoe dan ook kan bestellen. */
    var atcForm = root.querySelector('form.pdp-cta-form');
    if (atcForm && window.fetch && window.FormData) {
      var atcBtn = atcForm.querySelector('[data-pdp-cta]');
      var atcLabel = atcForm.querySelector('[data-pdp-cta-label]');
      var atcBezig = false;

      function ctaMelding(tekst) {
        if (!atcLabel) return;
        var oud = atcLabel.getAttribute('data-oud') || atcLabel.textContent;
        atcLabel.setAttribute('data-oud', oud);
        atcLabel.textContent = tekst;
        setTimeout(function () {
          atcLabel.textContent = atcLabel.getAttribute('data-oud') || oud;
          atcLabel.removeAttribute('data-oud');
        }, 2600);
      }

      atcForm.addEventListener('submit', function (e) {
        if (atcBezig) { e.preventDefault(); return; }
        e.preventDefault();

        atcBezig = true;
        // Alleen zelf uitzetten wat we ook zelf weer aan mogen zetten. Een
        // knop die al disabled stond (uitverkocht) laten we met rust.
        var zelfUitgezet = false;
        if (atcBtn && !atcBtn.disabled) { atcBtn.disabled = true; zelfUitgezet = true; }
        if (atcBtn) atcBtn.classList.add('is-loading');

        function klaar() {
          atcBezig = false;
          if (atcBtn) atcBtn.classList.remove('is-loading');
          if (atcBtn && zelfUitgezet) atcBtn.disabled = false;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(atcForm)
        })
          .then(function (r) {
            return r.json().then(function (d) { return { ok: r.ok, data: d }; });
          })
          .then(function (res) {
            klaar();
            if (!res.ok) {
              ctaMelding((res.data && res.data.description) || 'Niet gelukt');
              return;
            }
            // Lade verversen en openen. Het thema haalt de inhoud zelf op.
            document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
          })
          .catch(function () {
            // Netwerk of JSON stuk: gewone post, dan komt de klant op /cart uit.
            klaar();
            atcForm.submit();
          });
      });
    }

    /* ---------- Sticky CTA -> stuurt het echte buybox-formulier ---------- */
    root.querySelectorAll('[data-pdp-atc-proxy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var cta = root.querySelector('[data-pdp-cta]');
        if (cta) { cta.click(); return; }
        var form = root.querySelector('.pdp-buybox__inner, form[action*="/cart/add"]');
        if (form && form.requestSubmit) { form.requestSubmit(); }
        else if (form) { form.submit(); }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-main]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  // Shopify theme-editor herladen van sectie
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pdp-main]');
    if (el) initSection(el);
  });
})();